import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import styles from './index.css';

import { Dialog } from '../../../../../components/modal';

import { classNames } from '@ifeng-fe/container_channel/common/client/utils/classnames';

class More extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    /**
     * 插入html
     */

    handleClickRule = () => {
        Dialog.show({
            title: '关于美食盛典',
            content: (
                <div className={styles.content}>
                    <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
                </div>
            ),
        });
    };

    render() {
        return <div className={styles.more} onClick={this.handleClickRule} />;
    }
}

const RulesChip = props => (
    <Chip id="193945" type="static" title="2021美食盛典-活动介绍" groupName="正文-区域盛典" content={props.content}>
        <More />
    </Chip>
);

RulesChip.propTypes = {
    content: PropTypes.string,
};

export default errorBoundary(RulesChip);
